import { SignalTree } from "../types/signal-tree.type";
import { IAppStorage, IThemeSettingsStorage } from "../interfaces/app-storage-tree.interface";

// Verouderde, losse localStorage-keys die nu in de geconsolideerde user-boom leven.
const LEGACY = {
    themeSettings: 'reflecs.theme.settings',
    themeCache: 'reflecs.theme.cache',
    themeModes: 'reflecs.theme.modes',   // dood: nergens meer geschreven → alleen opruimen
    lang: 'reflecs-lang',
    i18nCachePrefix: 'reflecs-i18n-cache:v2:',
} as const;

const I18N_LANGS = ['nl', 'en'] as const;

function _parse<T>(raw: string | null): T | null {
    if (!raw) return null;
    try { return JSON.parse(raw) as T; } catch { return null; }
}

// Eenmalige, idempotente migratie: verplaatst de oude losse keys de boom in (alleen
// als de boom-tak nog leeg is) en ruimt de oude keys op. Veilig om elke boot te draaien.
export function migrateLegacyKeys(appData$$: SignalTree<IAppStorage>): void {
    if (typeof localStorage === 'undefined') return;

    // theme.settings + theme.cache
    if (appData$$.theme.settings() === undefined) {
        const __settings = _parse<IThemeSettingsStorage>(localStorage.getItem(LEGACY.themeSettings));
        if (__settings) appData$$.theme.settings.set(__settings);
    }
    if (appData$$.theme.cache() === undefined) {
        const __cache = _parse<unknown>(localStorage.getItem(LEGACY.themeCache));
        if (__cache) appData$$.theme.cache.set(__cache);
    }
    localStorage.removeItem(LEGACY.themeSettings);
    localStorage.removeItem(LEGACY.themeCache);
    localStorage.removeItem(LEGACY.themeModes);

    // i18n.lang
    if (appData$$.i18n.lang() === undefined) {
        const __lang = localStorage.getItem(LEGACY.lang);
        if (__lang) appData$$.i18n.lang.set(__lang);
    }
    localStorage.removeItem(LEGACY.lang);

    // i18n.cache (per taal)
    if (appData$$.i18n.cache() === undefined) {
        const __cache: Record<string, Record<string, string>> = {};
        for (const __lang of I18N_LANGS) {
            const __entry = _parse<Record<string, string>>(localStorage.getItem(LEGACY.i18nCachePrefix + __lang));
            if (__entry) __cache[__lang] = __entry;
        }
        if (Object.keys(__cache).length) appData$$.i18n.cache.set(__cache);
    }
    for (const __lang of I18N_LANGS) localStorage.removeItem(LEGACY.i18nCachePrefix + __lang);
}
